import store from '@/store';

const setRouterHistory = (to, from, next) => {
    store.dispatch('routerHistory/add', from);
    next();
};

export default setRouterHistory;
